/**
 * useForgotPasswordState — « Mot de passe oublié ? » (`reset-password`) : l'adresse, son envoi, la suite.
 *
 * Le portage de `src/auth/ForgotPassword.js` :
 *  - l'adresse se valide à l'envoi, puis à chaque frappe (`forgotPasswordEmailError`) ;
 *  - `POST api/password/email` part comme le legacy (`usePasswordFormSubmit`) ;
 *  - envoyé → les félicitations « Effectué » (au vouvoiement), puis l'écran `congrats`, qui reste legacy ;
 *  - un refus se lit sous le champ (`authErrorText`, les mots du serveur comme `ErrorTextM`) ;
 *  - « Recevoir un code » pousse `login` ; la flèche revient d'où l'on vient, sinon à l'accueil.
 *
 * La route garde `headerShown: true` pour le legacy : la page du DS porte sa propre flèche, l'en-tête
 * natif se masque donc au montage.
 */
import { useLayoutEffect, useState } from "react"
import { useNavigation } from "@react-navigation/native"

import { authService } from "../../../../../../data/services/authService"
import {
    FORGOT_PASSWORD_SENT,
    forgotPasswordEmailError,
} from "../../../../view-models/auth/Password/passwordFormViewModel"
import { useBackOr } from "../../../hooks/useBackOr"
import { usePasswordFormSubmit } from "../usePasswordFormSubmit"

export const FORGOT_PASSWORD_FAILED = "Le lien n'a pas pu partir. Réessayez dans un instant."

type ForgotPasswordNavigation = {
    push: (name: string) => void
    setOptions?: (options: object) => void
}

export function useForgotPasswordState() {
    const navigation = useNavigation<ForgotPasswordNavigation>()
    const onBack = useBackOr("menu")
    const [email, setEmail] = useState("")

    useLayoutEffect(() => {
        navigation.setOptions?.({ headerShown: false })
    }, [navigation])

    const { submitted, serverError, submitting, submit } = usePasswordFormSubmit({
        service: authService.sendResetPasswordLink,
        done: FORGOT_PASSWORD_SENT,
        fallback: FORGOT_PASSWORD_FAILED,
    })

    const emailError = forgotPasswordEmailError(email)

    return {
        email,
        onChangeEmail: setEmail,
        emailError: submitted ? emailError : undefined,
        serverError,
        submitting,
        onSubmit: () => submit({ email }, emailError != null),
        onRequestCode: () => navigation.push("login"),
        onBack,
    }
}
